import axios from "./_axios";
import { API } from "./apiEndPoints";

/**
 * Fetches the Organization health measures for one account (ER-12272).
 *
 * The v2 endpoint computes every number the card shows — the per-measure
 * `percent` and the `overall_percent` — so the front end never recomputes
 * them and simply renders the payload verbatim.
 *
 * @param {string|number} account_id - The account ID
 * @returns {Promise} Axios response with the organization-health payload
 */
export const getOrganizationHealth = async (account_id) => {
  const result = await axios()({
    method: "get",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/${API.ORGANIZATION_HEALTH}`,
    params: {}, // Explicitly empty: this call is unfiltered, like active-counts
    // Dashboard widget: a 404 must hide this card, not replace the page with
    // the app-wide not-found view (ER-12272 AC-14).
    skipNotFoundRouteError: true,
  });
  return result;
};
